import { Grid, Paper } from "@mui/material";
import { PageContainer } from "../../App/Components/PageContainer/PageContainer";
import { PageTitle } from "../../App/Components/PageTitle/PageTitle";
import Breadcrumb from "../../App/Components/Navigation/Subcomponents/Breadcrumbs/Breadcrumbs";
import TabGroup from "../../App/Components/TabGroup/TabGroup";
import { ITabGroupConfig, ITabPanel } from "../../App/Typings/TabPanel";
import EmailCampaignListingTab from "./Components/Tabs/EmailCampaignListingTab";
import EmailMessageListingTab from "./Components/Tabs/EmailMessageListingTab";
import { useFlags } from "launchdarkly-react-client-sdk";
import { IFeatureToggles } from "../../App/Typings/FeatureToggles";
import { useState } from "react";

export default function EmailMarketing() {
  const [selectedTab, setSelectedTab] = useState<string>("Emails");

  const { enableEmailMarketingCampaigns } = useFlags<IFeatureToggles>();

  const tabGroupConfig: ITabGroupConfig = {
    groupLabel: "Message Actions",
    id: "message-center-tabs",
    currentTabState: selectedTab ?? "Emails",
    fullWidth: false,
    changeTabState: setSelectedTab,
    tabs: [
      {
        label: "Emails",
        TabComponent: <EmailMessageListingTab />,
      },
      {
        label: "Message Campaigns",
        TabComponent: <EmailCampaignListingTab />,
      } as ITabPanel,
    ],
  };

  return (
    <PageContainer>
      <Grid container>
        <Grid item xs={12}>
          <Breadcrumb pageTitle="Email Marketing" />
        </Grid>
      </Grid>
      <Paper sx={{ mt: { xs: 1, md: 2 }, p: { xs: 2, lg: 4 }, flex: 1 }}>
        <Grid container>
          <Grid item xs={12} sx={{ marginBottom: "10px" }}>
            <PageTitle sx={{ lineHeight: 1 }}>Email Marketing</PageTitle>
          </Grid>
        </Grid>
        {enableEmailMarketingCampaigns ? <TabGroup config={tabGroupConfig} /> : <EmailMessageListingTab />}
      </Paper>
    </PageContainer>
  );
}
